function normalizeListItem(raw) {
    return {
        id: raw.id,
        uuid: raw.uuid,
        status: raw.status,
        amount: Number(raw.amount) / 100,
        currency: raw.currency,
        cardPanMasked: raw.card_pan_masked,
        fullName: raw.full_name,
        email: raw.email,
        phone: raw.phone,
        externalReference: raw.external_reference,
        documentDate: raw.document_date,
        description: raw.description,
        declineReason: raw.decline_reason,
        registryId: raw.registry_id,
        transactionId: raw.transaction_id,
        createdAt: raw.created_at,
        updatedAt: raw.updated_at,
        merchantName: raw.merchant_name,
        merchantUuid: raw.merchant_uuid,
        payoutType: raw.payout_type,
        sbpPhone: raw.sbp_phone,
        sbpBankBic: raw.sbp_bank_bic,
        sbpBankCode: raw.sbp_bank_code || raw.sbp_bank_bic,
        sbpBankName: raw.sbp_bank_name,
    };
}

var STATUS_CONFIG = [
    { status: 0, label: "Создана", color: "#546e7a", bg: "#eceff1" },
    { status: 1, label: "Антифрод", color: "#f57f17", bg: "#fff9c4" },
    { status: 7, label: "Ожидает выплаты", color: "#0277bd", bg: "#e1f5fe" },
    { status: 3, label: "В реестре", color: "#7b1fa2", bg: "#f3e5f5" },
    { status: 5, label: "Успех", color: "#2e7d32", bg: "#e8f5e9" },
    { status: 2, label: "Отклонена", color: "#c62828", bg: "#ffebee" },
    { status: 6, label: "Ошибка", color: "#ad1457", bg: "#fce4ec" },
];

// Сколько карточек грузим в колонку за один запрос
var COLUMN_PAGE_SIZE = 50;

/**
 * Собрать фильтры запроса из состояния страницы.
 * Статус сюда НЕ попадает: колонка доски задаёт его сама.
 */
function buildRequestFilters(appliedFilters, searchTags) {
    var f = {};
    var af = (appliedFilters && appliedFilters.filters) || {};

    if (af.dateFrom) f.dateFrom = af.dateFrom;
    if (af.dateTo) f.dateTo = af.dateTo;
    if (af.amountMin) f.amountMin = af.amountMin;
    if (af.amountMax) f.amountMax = af.amountMax;

    if (Array.isArray(searchTags)) {
        searchTags.forEach(function (tag) {
            if (tag.fullName) f.fullName = tag.fullName;
            if (tag.externalReference) f.externalReference = tag.externalReference;
            if (tag.cardMask) f.cardMask = tag.cardMask;
            if (tag.phone) f.phone = tag.phone;
            if (tag.merchantName) f.merchantName = tag.merchantName;
            if (tag.transactionId) f.transactionId = tag.transactionId;
        });
    }

    return f;
}

/**
 * Какие статусы грузить с сервера: все колонки доски либо только выбранные в фильтрах.
 */
function statusesToLoad(appliedFilters, boardStatuses) {
    var af = (appliedFilters && appliedFilters.filters) || {};
    var all = boardStatuses || [];

    if (af.status && af.status.length > 0) {
        var wanted = af.status.map(Number);
        return all.filter(function (s) {
            return wanted.indexOf(Number(s)) >= 0;
        });
    }

    return all.slice();
}

/**
 * Дописать страницу к уже загруженным карточкам колонки, без дублей по id.
 */
function mergeColumnItems(existing, incoming) {
    var result = (existing || []).slice();
    var seen = {};
    result.forEach(function (item) { seen[item.id] = true; });

    (incoming || []).forEach(function (item) {
        if (!seen[item.id]) {
            seen[item.id] = true;
            result.push(item);
        }
    });

    return result;
}

/**
 * Все загруженные карточки одним списком — для массовых действий и группировки на доске.
 */
function flattenColumns(columns) {
    var result = [];
    Object.keys(columns || {}).forEach(function (status) {
        var col = columns[status];
        if (col && Array.isArray(col.items)) {
            result = result.concat(col.items);
        }
    });
    return result;
}

/**
 * Сколько заявок в каждой колонке всего на сервере.
 */
function columnTotals(columns) {
    var totals = {};
    Object.keys(columns || {}).forEach(function (status) {
        var col = columns[status];
        totals[status] = col && typeof col.total === "number"
            ? col.total
            : (col && Array.isArray(col.items) ? col.items.length : 0);
    });
    return totals;
}

export {
    normalizeListItem,
    STATUS_CONFIG,
    COLUMN_PAGE_SIZE,
    buildRequestFilters,
    statusesToLoad,
    mergeColumnItems,
    flattenColumns,
    columnTotals,
};
export default {
    normalizeListItem,
    STATUS_CONFIG,
    COLUMN_PAGE_SIZE,
    buildRequestFilters,
    statusesToLoad,
    mergeColumnItems,
    flattenColumns,
    columnTotals,
};



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/CrmPayoutRequests/CrmPayoutRequestsUtils.js